export function DiamondIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none">
      <path
        d="M4 1L7 4L4 7L1 4L4 1Z"
        fill="url(#paint0_linear_148_6472)"
        stroke="url(#paint1_linear_148_6472)"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_148_6472"
          x1="1"
          y1="7"
          x2="8.21012"
          y2="4.52433"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#F3EBFF" />
          <stop offset="0.5" stop-color="#B98DFF" />
          <stop offset="1" stop-color="#5D2EFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_148_6472"
          x1="1"
          y1="7"
          x2="8.21012"
          y2="4.52433"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#F3EBFF" />
          <stop offset="0.5" stop-color="#B98DFF" />
          <stop offset="1" stop-color="#5D2EFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
